import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=09ed205b&scoped=true&"
import script from "./CitySelect.vue?vue&type=script&lang=js&"
export * from "./CitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed205b",
  null
  
)

export default component.exports